import React from "react";

type Props = {
    size?       :number,
    className?  : string,
    onClick     : func
}

export default function ControlButtonClose(props:Props) {

    const { size = 24 } = props;
    const classes = Classes(
        "ui5-control-button ui5-icon-close fs-14 ui5-color-system-black",
        "s-"+size,
        props.className
    )

    return (
        <div className={classes} onClick={props.onClick} />
    )

}